import { RegistrationFormKeys } from '@/types/registration-data'

export const MINUMUM_OPEN_MINUTES = 1440 // 24 hours

export const allAvailabilityFormKeys: RegistrationFormKeys[] = [
    RegistrationFormKeys.AVAILABLE_DURING_BREAK,
    RegistrationFormKeys.MONDAY,
    RegistrationFormKeys.MONDAY_1_A,
    RegistrationFormKeys.MONDAY_1_B,
    RegistrationFormKeys.MONDAY_2_A,
    RegistrationFormKeys.MONDAY_2_B,
    RegistrationFormKeys.MONDAY_2_B,
    RegistrationFormKeys.TUESDAY,
    RegistrationFormKeys.TUESDAY_1_A,
    RegistrationFormKeys.TUESDAY_1_B,
    RegistrationFormKeys.TUESDAY_2_A,
    RegistrationFormKeys.TUESDAY_2_B,
    RegistrationFormKeys.TUESDAY_2_B,
    RegistrationFormKeys.WEDNESDAY,
    RegistrationFormKeys.WEDNESDAY_1_A,
    RegistrationFormKeys.WEDNESDAY_1_B,
    RegistrationFormKeys.WEDNESDAY_2_A,
    RegistrationFormKeys.WEDNESDAY_2_B,
    RegistrationFormKeys.WEDNESDAY_2_B,
    RegistrationFormKeys.THURSDAY,
    RegistrationFormKeys.THURSDAY_1_A,
    RegistrationFormKeys.THURSDAY_1_B,
    RegistrationFormKeys.THURSDAY_2_A,
    RegistrationFormKeys.THURSDAY_2_B,
    RegistrationFormKeys.THURSDAY_2_B,
    RegistrationFormKeys.FRIDAY,
    RegistrationFormKeys.FRIDAY_1_A,
    RegistrationFormKeys.FRIDAY_1_B,
    RegistrationFormKeys.FRIDAY_2_A,
    RegistrationFormKeys.FRIDAY_2_B,
    RegistrationFormKeys.FRIDAY_2_B,
    RegistrationFormKeys.SATURDAY,
    RegistrationFormKeys.SATURDAY_1_A,
    RegistrationFormKeys.SATURDAY_1_B,
    RegistrationFormKeys.SATURDAY_2_A,
    RegistrationFormKeys.SATURDAY_2_B,
    RegistrationFormKeys.SATURDAY_2_B,
    RegistrationFormKeys.SUNDAY,
    RegistrationFormKeys.SUNDAY_1_A,
    RegistrationFormKeys.SUNDAY_1_B,
    RegistrationFormKeys.SUNDAY_2_A,
    RegistrationFormKeys.SUNDAY_2_B,
    RegistrationFormKeys.SUNDAY_2_B,
]

export const availabilityKeysPerDay: { [key in RegistrationFormKeys]?: RegistrationFormKeys[] } = {
    [RegistrationFormKeys.MONDAY]: [
        RegistrationFormKeys.MONDAY_1_A,
        RegistrationFormKeys.MONDAY_1_B,
        RegistrationFormKeys.MONDAY_2_A,
        RegistrationFormKeys.MONDAY_2_B,
    ],
    [RegistrationFormKeys.TUESDAY]: [
        RegistrationFormKeys.TUESDAY_1_A,
        RegistrationFormKeys.TUESDAY_1_B,
        RegistrationFormKeys.TUESDAY_2_A,
        RegistrationFormKeys.TUESDAY_2_B,
    ],
    [RegistrationFormKeys.WEDNESDAY]: [
        RegistrationFormKeys.WEDNESDAY_1_A,
        RegistrationFormKeys.WEDNESDAY_1_B,
        RegistrationFormKeys.WEDNESDAY_2_A,
        RegistrationFormKeys.WEDNESDAY_2_B,
    ],
    [RegistrationFormKeys.THURSDAY]: [
        RegistrationFormKeys.THURSDAY_1_A,
        RegistrationFormKeys.THURSDAY_1_B,
        RegistrationFormKeys.THURSDAY_2_A,
        RegistrationFormKeys.THURSDAY_2_B,
    ],
    [RegistrationFormKeys.FRIDAY]: [
        RegistrationFormKeys.FRIDAY_1_A,
        RegistrationFormKeys.FRIDAY_1_B,
        RegistrationFormKeys.FRIDAY_2_A,
        RegistrationFormKeys.FRIDAY_2_B,
    ],
    [RegistrationFormKeys.SATURDAY]: [
        RegistrationFormKeys.SATURDAY_1_A,
        RegistrationFormKeys.SATURDAY_1_B,
        RegistrationFormKeys.SATURDAY_2_A,
        RegistrationFormKeys.SATURDAY_2_B,
    ],
    [RegistrationFormKeys.SUNDAY]: [
        RegistrationFormKeys.SUNDAY_1_A,
        RegistrationFormKeys.SUNDAY_1_B,
        RegistrationFormKeys.SUNDAY_2_A,
        RegistrationFormKeys.SUNDAY_2_B,
    ],
}
